import React, { useState } from 'react';
import StepComponent from 'components/StepComponent/CustomSteps';
import { getStepsRoleType } from 'constants/inventorySteps';
import { useTranslation } from 'react-i18next';

const RoleTypeSteps: React.FC = () => {
  const { t } = useTranslation();
  const stepsRoleType = getStepsRoleType(t);
  const [current, setCurrent] = useState(0);
  const title = stepsRoleType[current]?.title;

  return (
    <StepComponent
      steps={stepsRoleType}
      current={current}
      onStepChange={setCurrent}
      title={title}
    />
  );
};

export default RoleTypeSteps;
